export default __webpack_public_path__ + "static/media/Pfeil_Blau_Nach_Rechts.e429cb79.svg";